import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  List,
  ListItemButton,
  ListItemText,
  Typography,
  IconButton,
  Paper
} from "@mui/material";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import RestoreIcon from "@mui/icons-material/Restore";
import FlipIcon from "@mui/icons-material/Flip";
import { getDocumentByFileStoreId } from "@egovernments/digit-ui-libraries/src/utils/fileType";

const InspectionPhotoViewer = ({ documentInspection = [] }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [zoom, setZoom] = useState(1);
  const [rotation, setRotation] = useState(0);
  const [mirror, setMirror] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
const [loading, setLoading] = useState(false);
// console.log(documentInspection, "documentInspection");

  useEffect(() => {
    // Reset index if the array updates
    if (documentInspection.length === 0) setSelectedIndex(-1);
    else setSelectedIndex(0);
  }, [documentInspection]);


  const handleSelect = (index) => {
    setSelectedIndex(index);
    setZoom(1);
    setRotation(0);
    setMirror(false);
  };

  const handleZoomIn = () => setZoom((z) => z + 0.25);
  const handleZoomOut = () => setZoom((z) => Math.max(0.25, z - 0.25));
  const handleRotate = () => setRotation((r) => r - 90);
  const handleReset = () => {
    setZoom(1);
    setRotation(0);
    setMirror(false);
  };

  const selectedImage =
    documentInspection && documentInspection[selectedIndex];

    console.log(selectedImage, "selectedImage");

//     useEffect(() => {
//       debugger;
//   if (selectedImage?.fileStoreId) {
//     fetch(`/fileStore/v1/files/id?fileStoreIds=${selectedImage.fileStoreId}&tenantId=default`)
//       .then(res => res.json())
//       .then(data => {
//         setImageUrl(data?.[selectedImage.fileStoreId]);
//       });
//   }
// }, [selectedImage]);

  useEffect(() => {
  const fetchImage = async () => {
    if (!selectedImage?.fileStoreId) return;

    const url = await getDocumentByFileStoreId(
      selectedImage.fileStoreId,
      setLoading,
      true // ✅ IMPORTANT: returns URL instead of opening
    );

    console.log("Fetched Image URL:", url);

    setImageUrl(url);
  };

  fetchImage();
}, [selectedImage]);

  return (
    <Grid container spacing={2}>
      {/* Left Panel - Image List */}
      <Grid item xs={3}>
        <Paper sx={{ height: "100%", overflowY: "auto" }}>
          <List dense>
            {documentInspection.map((doc, index) => (
              <ListItemButton
                key={doc.fileStoreId}
                selected={index === selectedIndex}
                onClick={() => handleSelect(index)}
              >
                <ListItemText
                  primary={doc.additionalDetails?.fileName || "Untitled"}
                  secondary={new Date().toLocaleString()}
                />
              </ListItemButton>
            ))}
          </List>
        </Paper>
      </Grid>

      {/* Right Panel - Image Preview */}
      <Grid item xs={9}>
        <Paper sx={{ p: 2 }}>
          {selectedImage ? (
            <React.Fragment>
              <Box
  sx={{
    textAlign: "center",
    height: 400, // ✅ REQUIRED
    overflow: "auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "1px solid #ccc",
    mb: 2
  }}
>
               {loading ? (
  <Typography>Loading image...</Typography>
) : imageUrl ? (
  <img
    src={imageUrl}
    alt={selectedImage.additionalDetails?.fileName}
    onError={() => console.log("❌ Image failed:", imageUrl)}
    style={{
      maxWidth: "100%",
      maxHeight: "100%",
      objectFit: "contain",
      transform: `scale(${zoom}) rotate(${rotation}deg) ${mirror ? "scaleX(-1)" : ""}`,
      transition: "transform 0.3s ease"
    }}
  />
) : (
  <Typography>No image available</Typography>
)}
              </Box>

              {/* Footer - Controls */}
              <Box display="flex" justifyContent="center" gap={2}>
                <IconButton color="success" onClick={handleZoomIn}><ZoomInIcon /></IconButton>
                <IconButton color="success" onClick={handleZoomOut}><ZoomOutIcon /></IconButton>
                <IconButton color="success" onClick={handleRotate}><RotateLeftIcon /></IconButton>
                <IconButton color="success" onClick={() => setMirror((prev) => !prev)} title="Mirror">
                  <FlipIcon  />
                </IconButton>
                <IconButton color="success" onClick={handleReset}><RestoreIcon /></IconButton>
              </Box>

              <Typography align="center" mt={1}>
                Zoom: {(zoom * 100).toFixed(0)}% | Rotation: {rotation}°
              </Typography>
            </React.Fragment>
          ) : (
            <Typography variant="body1" align="center">
              No image selected or available.
            </Typography>
          )}
        </Paper>
      </Grid>
    </Grid>
  );
};

export default InspectionPhotoViewer;
